// Features/External-Links/mod.ts
var { debug } = console;
var { host } = window.location;
var toURL = (href) => {
  try {
    return new URL(href);
  } catch (_) {
  }
};
var isExternal = (link) => toURL(link.href)?.host !== host;
var patch = (link) => link.target = "_blank";
debug(`[ \uD83D\uDD17 ]: Making all external links open in new tabs.`);
var links = document.getElementsByTagName("a");
var external = Array.from(links).filter(isExternal);
external.forEach(patch);
debug(`[ \uD83D\uDD17 ]: Patched ( ${external.length} of ${links.length} ) links to open in new tabs.`);
